import React from "react";
import { Box, Typography, Button } from "@mui/material";

// Define your default styles
const defaultStyles = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  padding: "32px",
  gap: "15px",
  textAlign: "center",
};

const EmptyUI = ({
  heading,
  subHeading,
  styles,
  icon,
  iconStyles,
  actionLabel,
  onActionClick,
  actionIcon,
  textColor,
}) => {
  return (
    <Box style={{ ...defaultStyles, ...styles }}>
      {/* Render the icon dynamically based on the prop */}
      {icon && React.cloneElement(icon, { sx: iconStyles })}
      <Typography
        variant="h5"
        sx={{
          color: textColor,
          fontWeight: "500",
          fontFamily: "Action NBA Web",
          fontSize: "clamp(1rem, 1vw + 1rem, 2rem)",
        }}
      >
        {heading}
      </Typography>
      <Typography
        variant="body1"
        color="textPrimary"
        sx={{
          fontSize: "clamp(0.5rem, 1vw + 0.5rem, 1rem)",
        }}
      >
        {subHeading}
      </Typography>
      {actionLabel && onActionClick && (
        <Button
          variant="contained"
          color="primary"
          size="medium"
          onClick={onActionClick}
          startIcon={actionIcon}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

export default EmptyUI;
